// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__NQXy-","unreadBadge":"styles_unreadBadge__2gQAt","modalContent":"styles_modalContent__2AjNY","modal":"styles_modal__3DEu3"};